module.exports = __webpack_public_path__ + "img/sand-decal-09.a905f3af.png";